export function formatCurrency(amount: number, currency = 'USD'): string {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency,
  }).format(amount)
}

export function formatDate(date: string | Date): string {
  return new Intl.DateTimeFormat('es-AR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date))
}

export function formatNumber(num: number): string {
  return new Intl.NumberFormat('es-AR').format(num)
}

export function formatDateTime(date: string | Date): string {
  const d = new Date(date)
  return (
    d.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
    ' ' + d.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })
  )
}

export function relTime(date: string | Date): string {
  const diff = (Date.now() - new Date(date).getTime()) / 1000
  if (diff < 60) return 'hace ' + Math.max(1, Math.floor(diff)) + 's'
  if (diff < 3600) return 'hace ' + Math.floor(diff / 60) + 'min'
  if (diff < 86400) return 'hace ' + Math.floor(diff / 3600) + 'h'
  if (diff < 86400 * 7) return 'hace ' + Math.floor(diff / 86400) + 'd'
  if (diff < 86400 * 30) return 'hace ' + Math.floor(diff / 86400 / 7) + 'sem'
  return 'hace ' + Math.floor(diff / 86400 / 30) + ' meses'
}
